<div class="typing-indicator text-primary" *ngIf="memberTypingName">
  <span class="typing-user" data-test-id="typing-user-name">{{ memberTypingName }} </span>
  <span class="w-100p" data-test-id="typing-hint"> &nbsp; {{ placeholderPhrases.typingHint | translate }}</span>
</div>
<div class="d-flex my-1">
  <div *ngIf="userAvatarVisibility">
    <app-small-profile-image
      [profileImage]="currentUserImage"
      [accountStatus]="currentUserAccountStatus"
      [dataTestId]="'current-user-avatar'"
      [link]="getLink()"
    ></app-small-profile-image>
  </div>
  <div class="message-form media-body w-100 ms-2">
    <form [formGroup]="messageForm">
      <textarea
        class="form-control"
        data-test-id="conversation-textarea"
        formControlName="messageInput"
        rows="3"
        [ngClass]="{
          invalid: (messageForm.dirty || messageSubmitted) && messageForm.invalid && inputMessage.value.length >= 1
        }"
        [readOnly]="isReadOnly"
        [placeholder]="placeholderPhrases.inputPlaceholder | translate"
        (keyup)="onKeyUpEvent($event)"
        (keydown)="onKeyDownEvent($event)"
        appTrimOnBlur
        #inputMessage
      >
      </textarea>
      <div class="d-flex justify-content-start align-items-center mt-3 mb-3">
        <div class="d-flex justify-content-start align-items-center">
          <button
            appLongOperation
            id="btn-send-message"
            [attr.data-test-id]="'btn-send-message-' + indexLabel"
            [disabled]="messageForm.invalid || isReadOnly || !inputMessage.value.length"
            (click)="submitMessage()"
            type="button"
            class="btn btn-primary"
          >
            {{ placeholderPhrases.buttonHint | translate }}
          </button>
        </div>
        <ng-container *ngIf="(messageInput.dirty || messageSubmitted) && messageInput.errors">
          <ng-template
            *ngIf="getValidationError"
            [ngTemplateOutlet]="errorTemplate"
            [ngTemplateOutletContext]="{ cssClass: 'text-danger w-75 ps-4 white-space-i hide-section' }"
          ></ng-template>
        </ng-container>
        <div *ngIf="counterVisibility" class="ms-auto ps-2 align-self-start">
          <app-counter
            class="ms-auto mt-1"
            [maxLength]="maxLength"
            [isFieldInvalid]="messageForm.invalid && inputMessage.value.length"
            [dataTestId]="'comment-max-length-counter'"
            [valueLength]="inputMessage.value.length"
          >
          </app-counter>
        </div>
      </div>
      <ng-container *ngIf="(messageInput.dirty || messageSubmitted) && messageInput.errors">
        <ng-template
          *ngIf="getValidationError"
          [ngTemplateOutlet]="errorTemplate"
          [ngTemplateOutletContext]="{ cssClass: 'text-danger w-100 white-space-i show-section' }"
        ></ng-template>
      </ng-container>
    </form>
  </div>
</div>

<ng-template #errorTemplate let-cssClass="cssClass">
  <small [class]="cssClass" data-test-id="messsage-input-error-max-length">
    {{
      getValidationError()
        | translate
          : {
              maxlength: maxLength
            }
    }}
  </small>
</ng-template>
